// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2Qg6y","containerItemsCenter":"Skeleton_containerItemsCenter__2W7nj"};